import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';

import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { MwCorePreferenceService } from '../..';
import { MwCorePreferenceModel } from '../../models/preference.model';

@Injectable()
export class PreferenceResolve implements Resolve<MwCorePreferenceModel> {
  constructor(private preferenceService: MwCorePreferenceService) {}
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    return this.preferenceService.preference$.pipe(take(1));
  }
}
